import Styles from './ChallengeInfo.module.scss';
import { useState, useEffect } from 'react';

// Module imports
import { ListItem, ListItemText, ListItemAvatar, Avatar, Paper, Tooltip } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TryIcon from '@mui/icons-material/Try';

// Components imports.
import { useTranslation } from 'components/lib';
import { CircularProgressWithLabel } from './CircularProgress';

export function ChallengeInfo(props) {

    const [progressShake, setProgressShake] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (props.numTestUncovered !== undefined && props.numTestUncovered !== 0) {
            setProgressShake(true);
            setTimeout(() => {
                setProgressShake(false);
            }, 500); // adjust the time as needed
        }
    }, [props.numTestUncovered]);



    return (
        <>
            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.challengeInfo.tooltip.testCase')}>
                <Paper elevation={3} sx={{ width: '100%' }} id="testCases" className={progressShake ? Styles.changeTestCase : Styles.hoverEffect}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar sx={{ background: "linear-gradient(to right, #ffecb3, #ffe082, #ffd54f, #ffca28, #ffc107)" }}>
                                <ListAltIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.challengeInfo.listItem.testCase')}
                            primary={
                                `${props.numTestUncovered}/${props.numOfTestCases}`
                            }
                        />
                    </ListItem>
                </Paper>
            </Tooltip>
            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.challengeInfo.tooltip.attempt')}>
                <Paper elevation={3} sx={{ width: '100%' }} id="numAttempts"
                    className={props.attemptsShake ? Styles.changeAttempts : Styles.hoverEffect}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar sx={{ background: "linear-gradient(to right, #ef9a9a, #e57373, #ef5350, #e53935)" }} >
                                <TryIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.challengeInfo.listItem.attempt')} primary={
                            props.attemptsExceeded
                                ? `${props.attempts}/${props.attempts}`
                                : `${props.currentAttempts}/${props.attempts}`} />
                    </ListItem>
                </Paper>
            </Tooltip>
            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.challengeInfo.tooltip.percent')}>
                <Paper elevation={3} sx={{ width: '100%' }} id="progress" className={Styles.hoverEffect}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar sx={{ background: "linear-gradient(to right, #e0f2f1, #80cbc4)", height: "39px", width: "39px" }}>
                                <CircularProgressWithLabel value={props.progressPercent} />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.challengeInfo.listItem.percent')} primary={`${props.minPercent}%`} />
                    </ListItem>
                </Paper>
            </Tooltip>
        </>
    );
}